/**
*
* useRecipientRoles
*
*/

import useCurrentRole from 'containers/User/useCurrentRole.js';
import { BETA_MODULES_INBOX } from 'containers/User/constants.js';
import { CONVERSATIONROLES, INBOX_ROLE } from './constants.jsx';

function useRecipientRoles() {
  const role = useCurrentRole();
  const withInboxes = role.school.betaModules?.includes(BETA_MODULES_INBOX);
  return withInboxes ? CONVERSATIONROLES : CONVERSATIONROLES.filter((r) => r.id !== INBOX_ROLE);
}

export default useRecipientRoles;
